import { assign } from 'lodash';
import * as apiPersonal from 'api/api-personal';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saved: false,
  saveError: null,
  error: null,
  notFound: null,
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saved: false,
  saveError: null,
  error: null,
  notFound: null,
};

const state = assign({}, initState);

const getters = {
  PersonalEmailChange: state => state,
};

const actions = {
  MakePersonalEmailChange({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const payload = params.payload;
      commit(types.PERSONAL_EMAIL_CHANGE_START);
      apiPersonal.personalChangeEmail(
        payload,
        (response) => {
          commit(types.PERSONAL_EMAIL_CHANGE_SUCCESSFUL, { response });
          dispatch('ChangePersonalProfileEmail', { email: payload.email, email_verified: false });
          resolve(true);
        },
        (error, status, saveError) => {
          commit(types.PERSONAL_EMAIL_CHANGE_ERROR, { saveError });
          reject(saveError);
        },
      );
    });
  },
  ClearPersonalEmailChange({ commit }) {
    commit(types.CLEAR_PERSONAL_EMAIL_CHANGE_STORE);
  },
};

const mutations = {
  [types.PERSONAL_EMAIL_CHANGE_START](state) {
    assign(state, neutralState, { saving: true });
  },
  [types.PERSONAL_EMAIL_CHANGE_ERROR](state, { saveError }) {
    assign(state, neutralState, { saveError });
  },
  [types.PERSONAL_EMAIL_CHANGE_SUCCESSFUL](state, { response }) {
    assign(state, neutralState, { saved: true, data: response.data, meta: response.meta });
  },
  [types.CLEAR_PERSONAL_EMAIL_CHANGE_STORE](state) {
    assign(state, initState);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/personal/entities/personal-email-change.js